import React, { useEffect, useState } from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import { Link, useLocation } from 'react-router-dom';
import Loader from '../../components/loader/loader';
import { getErrorLogDetails } from '../../api/context/report';
import moment from 'moment';
import { Table } from 'react-bootstrap';

const ErrorReportDetails = () => {
    const { state } = useLocation();
    const id = state?.reportId;
    const [loading, setLoading] = useState(false);
    const [errorLogDetails, setErrorLogDetails] = useState([]);

    useEffect(() => {
        if (id) {
            setLoading(true);
            getErrorLogDetails(id)((response) => {
                if (response?.data?.status_code === 200) {
                    setErrorLogDetails(response?.data?.data);
                    setLoading(false);
                } else {
                    setErrorLogDetails([]);
                    setLoading(false);
                }
            });
        }
    }, [id]);

    const parseContent = (content) => {
        try {
            return JSON.parse(content.replace(/'/g, '"')); // Replace single quotes with double quotes to parse as JSON
        } catch (error) {
            console.error("Failed to parse content:", error);
            return null;
        }
    };

    const parsePayload = (payload) => {
        if (!payload) return {};
        const entries = payload.split(/\s(?=\w+=)/);
        const result = entries.reduce((acc, entry) => {
            const [key, value] = entry.split('=');
            if (key.trim() === 'global_parameters') {
                try {
                    acc[key.trim()] = JSON.parse(value.replace(/'/g, '"'));
                } catch (e) {
                    console.error("Failed to parse global_parameters:", e);
                    acc[key.trim()] = {}; // Set an empty object if parsing fails
                }
            }
            // Ensure 'recipients' is not parsed or stored
            else if (key.trim() !== 'recipients') {
                acc[key.trim()] = value?.trim();
            }
            return acc;
        }, {});
        return result;
    };


    const parsedContent = errorLogDetails ? parseContent(errorLogDetails.content) : null;
    const parsedPayload = errorLogDetails?.payload ? parsePayload(errorLogDetails.payload) : {};
    const globalParameters = parsedPayload?.global_parameters || {};

    return (
        <>
            <div className='order_details_wrapper'>
                {loading ? (
                    <Loader />
                ) : (
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center">
                                <Link to='/error-report' className='back_btn_wrap'>
                                    <IoMdArrowBack className='icon' />
                                </Link>
                                <h4 className="mb-sm-0">Error Report Details</h4>
                            </div>
                        </div>
                        <div className='col-12 '>
                            <div className='new-class'>
                                <div className=''>
                                    <div className='user_details_wrapper'>
                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <div className='user_details'>
                                                    <h4>Report Details</h4>
                                                    <Table>
                                                        <tbody>
                                                            <tr>
                                                                <td className='user-details-subheading'>Template:</td>
                                                                <td className='user-details-data'>{errorLogDetails?.template}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='user-details-subheading'>Date Sent:</td>
                                                                <td className='user-details-data'>{moment(errorLogDetails?.created_date).format('DD/MM/YYYY, hh:mm a')}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                    <h5>Error Details</h5>
                                                    {parsedContent ? (
                                                        <Table>
                                                            <colgroup>
                                                                <col style={{ width: '50%' }} />
                                                                <col style={{ width: '50%' }} />
                                                            </colgroup>
                                                            <thead className='border-0'>
                                                                <tr>
                                                                    <th>Field</th>
                                                                    <th>Error Message</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {parsedContent.map((item, index) => (
                                                                    Object.entries(item).map(([field, messages]) => (
                                                                        <tr key={`${index}-${field}`}>
                                                                            <td>{field}</td>
                                                                            <td className='error_msg_red'>{messages.join(', ')}</td>
                                                                        </tr>
                                                                    ))
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    ) : (
                                                        <p>No structured content available.</p>
                                                    )}
                                                    <h5>Payload Details</h5>
                                                    <Table>
                                                        <colgroup>
                                                            <col style={{ width: '50%' }} />
                                                            <col style={{ width: '50%' }} />
                                                        </colgroup>
                                                        <thead className='border-0'>
                                                            <tr>
                                                                <th>Field</th>
                                                                <th>Value</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.entries(parsedPayload).map(([key, value], index) => (
                                                                key !== 'global_parameters' && (
                                                                    <tr key={index}>
                                                                        <td>{key}</td>
                                                                        <td>{value}</td>
                                                                    </tr>
                                                                )
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                    <h5>Global Parameters</h5>
                                                    {Object.keys(globalParameters).length > 0 ? (
                                                        <Table>
                                                            <colgroup>
                                                                <col style={{ width: '50%' }} />
                                                                <col style={{ width: '50%' }} />
                                                            </colgroup>
                                                            <thead className='border-0'>
                                                                <tr>
                                                                    <th>Field</th>
                                                                    <th>Value</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {Object.entries(globalParameters).map(([key, value], index) => (
                                                                    <tr key={index}>
                                                                        <td>{key}</td>
                                                                        <td>{value}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    ) : (
                                                        <p>No global parameters available.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ErrorReportDetails;
